
  $(document).ready(function(){ 
    var navHeight = $('.main-navigation').outerHeight();
    $('#MainContent').css('margin-top', navHeight + 'px');
  });


/* --------------------------
   UNIVERSAL ADD-TO-CART LISTENER
--------------------------- */
// 1. Button click (ANY add-to-cart button)
document.addEventListener("click", (e) => {
  if (e.target.closest('[name="add"]') || e.target.closest('.ProductForm__AddToCart')) {
   // console.log("🟠 Add to cart button clicked");
    fireStarConfetti();
  }
});
// 2. Shopify AJAX / ProductForm add-to-cart
document.addEventListener("product:added", (e) => {
  //console.log("🟢 product:added event fired");
  fireStarConfetti();
});
// 3. UpCart public event
window.addEventListener("aftersell-upcart:public-events:cart-updated", (e) => {
  //console.log("🔵 UpCart cart-updated fired");
  fireStarConfetti();
});
// 4. Intercept ANY fetch to /cart/add.js (works for AJAX carts)
const originalFetch = window.fetch;
window.fetch = function() {
  const url = arguments[0];
  if (typeof url === "string" && url.includes("/cart/add")) {
    //console.log("🟣 fetch → /cart/add detected");
    fireStarConfetti();
  }
  return originalFetch.apply(this, arguments);
};

// XHR fallback
const originalSend = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.send = function(body) {
  this.addEventListener("load", () => {
    if (this.responseURL && this.responseURL.includes("/cart/add")) {
      //console.log("🟡 XHR → /cart/add detected");
      fireStarConfetti();
    }
  });
  originalSend.call(this, body);
};


/* --------------------------
   CONFETTI FUNCTION
--------------------------- */
function fireStarConfetti() {
  console.log("🎉 fireStarConfetti() triggered");
  const starUrl = "https://cdn.shopify.com/s/files/1/0043/1548/0177/files/star.png?v=1763353658";
  const duration = 2800; // 5 seconds
  const interval = 80; // how often to drop new stars
  const endTime = Date.now() + duration;
  const dropInterval = setInterval(() => {
    if (Date.now() > endTime) {
      clearInterval(dropInterval);
      //console.log("⏹ Confetti ended");
      return;
    }

    createStarParticle(starUrl);

  }, interval);
}

function createStarParticle(starUrl) {
  const particle = document.createElement("img");
  particle.src = starUrl;
  particle.classList.add("star-confetti");
  const size = Math.floor(Math.random() * 11) + 20;
  const startX = Math.random() * window.innerWidth;
  const driftX = Math.random() * 200 - 100;

  const rotation = Math.random() * 360;

  particle.style.position = "fixed";
  particle.style.left = `${startX}px`;
  particle.style.top = "-20px";
  particle.style.width = `${size}px`;
  particle.style.height = `${size}px`;
  particle.style.pointerEvents = "none";
  particle.style.opacity = "1";
  particle.style.transform = `rotate(${rotation}deg)`;
  particle.style.zIndex = "999999";

  document.body.appendChild(particle);

  const fallDuration = 1800 + Math.random() * 1200; // 1.8s–3s
  const endY = window.innerHeight + 40;

  particle.animate(
    [
      { transform: `translate(0, 0) rotate(${rotation}deg)`, opacity: 1 },
      { transform: `translate(${driftX}px, ${endY}px) rotate(${rotation + 120}deg)`, opacity: 0 }
    ],
    {
      duration: fallDuration,
      easing: "ease-out"
    }
  );

  setTimeout(() => particle.remove(), fallDuration + 50);
}





/* Christmas Flipper */
const cdnBase = "https://cdn.shopify.com/s/files/1/0043/1548/0177/files/";
const eggOffers = {
  blue: [
    { img: 'OFFER-POP-UP-01.png', type: 'discount', code: 'XMAS20' },
    { img: 'OFFER-POP-UP-05.png', type: 'discount', code: 'XMASEXPRESS' },
    { img: 'OFFER-POP-UP-03.png', type: 'product_with_discount', productId: '52968685764972', discountCode: 'XMASILMINI' },
    { img: 'OFFER-POP-UP-02.png', type: 'discount', code: 'XMAS15' },
    { img: 'OFFER-POP-UP-04.png', type: 'product_with_discount', productId: '52963146203500', discountCode: 'XMASOIL' }
  ],
  yellow: [
    { img: 'OFFER-POP-UP-01.png', type: 'discount', code: 'XMAS20' },
    { img: 'OFFER-POP-UP-05.png', type: 'discount', code: 'XMASEXPRESS' },
    { img: 'OFFER-POP-UP-03.png', type: 'product_with_discount', productId: '52968685764972', discountCode: 'XMASILMINI' },
    { img: 'OFFER-POP-UP-02.png', type: 'discount', code: 'XMAS15' },
    { img: 'OFFER-POP-UP-04.png', type: 'product_with_discount', productId: '52963146203500', discountCode: 'XMASOIL' }
  ],
  pink: [
    { img: 'OFFER-POP-UP-01.png', type: 'discount', code: 'XMAS20' },
    { img: 'OFFER-POP-UP-05.png', type: 'discount', code: 'XMASEXPRESS' },
    { img: 'OFFER-POP-UP-03.png', type: 'product_with_discount', productId: '52968685764972', discountCode: 'XMASILMINI' },
    { img: 'OFFER-POP-UP-02.png', type: 'discount', code: 'XMAS15' },
    { img: 'OFFER-POP-UP-04.png', type: 'product_with_discount', productId: '52963146203500', discountCode: 'XMASOIL' }
  ]
};
let eggRateLocked = false;
function showSpinner(eggImgSrc) {
  const wrapper = document.getElementById('egg-spinner');
  const img = document.getElementById('egg-spinner-img');
  if (img && eggImgSrc) img.src = eggImgSrc;
  if (wrapper) wrapper.style.display = 'flex';
}

function hideSpinner() {
  const wrapper = document.getElementById('egg-spinner');
  if (wrapper) wrapper.style.display = 'none';
}

// Preload all back images
Object.values(eggOffers).flat().forEach(offer => {
  const img = new Image();
  img.src = `${cdnBase}${offer.img}?v=1744699150`;
});




function applyOffer(offer) {
  const currentURL = window.location.pathname + window.location.search;
  const spinnerText = document.getElementById('egg-spinner-text');
  const expressPrize = document.querySelector('.express-prize');
  const prevBonus = JSON.parse(sessionStorage.getItem('bonusProduct') || 'null');
  const prevDiscount = sessionStorage.getItem('activeDiscountCode');

 const removePreviousPrize = () => {
  return new Promise((resolve) => {
    const bonusJSON = sessionStorage.getItem('bonusProduct');
    const prevBonus = bonusJSON ? JSON.parse(bonusJSON) : null;

    if (prevBonus) {
      // Remove the bonus product from the cart
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: prevBonus.productId, quantity: 0 })
      })
      .then(() => {
        console.log(`[Flipper] Removed previous bonus product ID ${prevBonus.productId}`);
        // Only clear session after removal attempt finishes
        sessionStorage.removeItem('activeDiscountCode');
        sessionStorage.removeItem('bonusProduct');
        resolve();
      })
      .catch(err => {
        console.warn('[Flipper] Failed to remove previous bonus product:', err);
        // Clear session even on failure
        sessionStorage.removeItem('activeDiscountCode');
        sessionStorage.removeItem('bonusProduct');
        resolve();
      });
    } else {
      resolve();
    }
  });
};


const applyDiscountRedirect = (code) => {
  sessionStorage.setItem('activeDiscountCode', code);
 sessionStorage.setItem('openCartAfterDiscount', 'true');

  if (code === 'XMASEXPRESS') {
    if (spinnerText) spinnerText.textContent = "Your FREE Express Shipping will be visible whilst Checking Out";
    if (expressPrize) expressPrize.classList.add('active');
  }

  setTimeout(() => {
    hideSpinner();
    window.location.href = `/discount/${code}?redirect=${encodeURIComponent(currentURL)}`;
  }, 1000);
};


  const addBonusProductAndApplyDiscount = () => {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: offer.productId, quantity: 1 })
    })
    .then(res => res.json())
    .then(() => {
      sessionStorage.setItem('activeDiscountCode', offer.discountCode);
      sessionStorage.setItem('bonusProduct', JSON.stringify({
        productId: offer.productId,
        discountCode: offer.discountCode
      }));

      if (offer.discountCode === 'XMASEXPRESS') {
        if (spinnerText) spinnerText.textContent = "Your FREE Express Shipping will be visible when Checking Out";
        if (expressPrize) expressPrize.classList.add('active');
      }

      if (window.UpCart) UpCart.refreshCart();

      setTimeout(() => {
        hideSpinner();
        window.location.href = `/discount/${offer.discountCode}?redirect=${encodeURIComponent(currentURL)}`;
      }, 1100);
    })
    .catch(err => {
      alert('❌ Add to cart failed: ' + err);
      hideSpinner();
      eggRateLocked = false;
    });
  };

  removePreviousPrize().then(() => {
    // 🥚 DISCOUNT ONLY
    if (offer.type === 'discount') {
      console.log('[Flipper] Applying discount-only offer:', offer.code);
      applyDiscountRedirect(offer.code);
    }

    // 🥚 PRODUCT + DISCOUNT
    else if (offer.type === 'product_with_discount') {
      console.log('[Flipper] Applying product + discount offer:', offer.productId, offer.discountCode);
      addBonusProductAndApplyDiscount();
    }
  });
}

function monitorCartRewardCleanup() {
  const CHECK_INTERVAL = 3500;

  setInterval(() => {
    const bonus = JSON.parse(sessionStorage.getItem('bonusProduct') || 'null');
    const activeCode = sessionStorage.getItem('activeDiscountCode');

    if (!bonus || !activeCode) return;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const discountExists = cart.cart_level_discount_applications?.some(
          d => d.code === bonus.discountCode
        );
        const productInCart = cart.items?.some(
          item => item.variant_id == bonus.productId
        );

        if (!discountExists && productInCart) {
          console.log('[Flipper] Bonus product in cart without matching discount. Removing…');

          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: bonus.productId, quantity: 0 })
          })
          .then(() => {
            sessionStorage.removeItem('activeDiscountCode');
            sessionStorage.removeItem('bonusProduct');
            if (window.UpCart) UpCart.refreshCart();

            const expressPrize = document.querySelector('.express-prize');
            if (expressPrize) expressPrize.classList.remove('active');

            console.log(`[Flipper] Removed bonus product ${bonus.productId} after discount was removed.`);
          })
          .catch(err => console.warn('❌ Bonus product cleanup failed:', err));
        }
      })
      .catch(err => console.warn('❌ Cart fetch failed for reward cleanup:', err));
  }, CHECK_INTERVAL);
}

function pickWeightedReward(rewards, discountWeight = 0.65) {
  const discounts = rewards.filter(r => r.type === 'discount');
  const productWithDiscounts = rewards.filter(r => r.type === 'product_with_discount');

  const roll = Math.random();
  console.log(`[Flipper] 🎲 Random roll: ${roll.toFixed(4)} (threshold: ${discountWeight})`);

  let chosen = null;

  if (roll < discountWeight && discounts.length > 0) {
    chosen = discounts[Math.floor(Math.random() * discounts.length)];
    console.log('[Flipper] 🎁 Chosen type: discount');
  } else if (productWithDiscounts.length > 0) {
    chosen = productWithDiscounts[Math.floor(Math.random() * productWithDiscounts.length)];
    console.log('[Flipper] 🎁 Chosen type: product_with_discount');
  } else if (discounts.length > 0) {
    chosen = discounts[Math.floor(Math.random() * discounts.length)];
    console.log('[Flipper] 🎁 Fallback: discount (only type left)');
  }

  return chosen;
}



document.querySelectorAll('.flip-container').forEach(container => {
  container.addEventListener('click', () => {
    if (container.classList.contains('flipped')) return;

    const color = container.dataset.color;
    const offers = eggOffers[color];
    const chosen = pickWeightedReward(offers); // ← using weighted logic now

    if (!chosen) return; // safety check

    const backImg = container.querySelector('.back');
    const backImgUrl = `${cdnBase}${chosen.img}?v=1744699150`;
    backImg.src = backImgUrl;

    backImg.onload = () => {
      container.classList.add('flipped');
      setTimeout(() => {
        showSpinner(backImgUrl);
        applyOffer(chosen);
      }, 900);
    };
  });
});


window.addEventListener('load', function() {
  // Delay a bit to ensure all scripts are fully initialized
  setTimeout(function(){
    if (sessionStorage.getItem('openCartAfterDiscount') === 'true') {
      sessionStorage.removeItem('openCartAfterDiscount');
      if (window.UpCart && typeof window.UpCart.openCart === 'function') {
        console.log('[Flipper] Opening cart via UpCart.openCart()');
        window.UpCart.openCart();
      } else {
        // Fallback: adjust the selector to match your theme's cart toggle element
        var cartToggleButton = document.querySelector('.header__icon--cart');
        if (cartToggleButton) {
          console.log('[Flipper] Opening cart via simulated click.');
          cartToggleButton.click();
        } else {
          console.warn('[Flipper] Cart toggle button not found.');
        }
      }
    }
  }, 1500); // adjust delay if necessary
});

